import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import Projecten from "@/pages/Projecten";
import Over from "@/pages/Over";
import Offerte from "@/pages/Offerte";
import Contact from "@/pages/Contact";
import Subsidie from "@/pages/Subsidie";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kunststof-kozijnen" element={<ProductPage slug="kunststof-kozijnen" />} />
          <Route path="/deuren" element={<ProductPage slug="deuren" />} />
          <Route path="/schuifpuien" element={<ProductPage slug="schuifpuien" />} />
          <Route path="/projecten" element={<Projecten />} />
          <Route path="/over" element={<Over />} />
          <Route path="/offerte" element={<Offerte />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/subsidie" element={<Subsidie />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
